"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Simplex = _interopRequireWildcard(require("../libs/Simplex"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default,
    UserAvatar: _UserAvatar.default
  },
  props: ['network', 'user', 'nicklist'],
  data: function data() {
    return {
      remoteSimplexAddress: Simplex.getRemoteSimplexAddress(this.network.id, this.user.nick)
    };
  },
  computed: {
    dataAttributes: function dataAttributes() {
      var attrs = Object.create(null);
      attrs['data-nick'] = this.user.nick.toLowerCase();
      if (this.user.account) {
        attrs['data-account'] = this.user.account.toLowerCase();
      }
      var userMode = this.nicklist.buffer.userMode(this.user);
      if (userMode) {
        attrs['data-mode'] = userMode;
      }
      return attrs;
    },
    userColour: function userColour() {
      // Check if gender-based coloring should be applied
      if (this.getGender) {
        if (this.getGender === 'Uomo') {
          return '#1E90FF';
        } else if (this.getGender === 'Donna') {
          return '#FF1493';
        }
      }

      // Fall back to nick-based coloring if enabled
      if (this.nicklist.useColouredNicks) {
        return '#81C784';
      }
      return '';
    },
    userModePrefix: function userModePrefix() {
      return this.nicklist.buffer.userModePrefix(this.user);
    },
    userTypingState: function userTypingState() {
      var status = this.user.typingStatus(this.nicklist.buffer.name).status;
      // console.log('userTypingState', this.user.nick, status);
      return status;
    },
    showSimplexBadge: function showSimplexBadge() {
      if (this.user.hasSimplex) {
        return true;
      }
      if (this.user === this.network.currentUser()) {
        return !!Simplex.getSimplexAddress();
      }
      return !!this.remoteSimplexAddress;
    },
    getGender: function getGender() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        switch (parsed.gender) {
          case 'M':
            return 'Uomo';
          case 'F':
            return 'Donna';
          case 'N':
            return 'Non binario';
          default:
            return null;
        }
      }
      return null;
    },
    getAge: function getAge() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        return parsed.age ? parsed.age : null;
      }
      return null;
    },
    getProvince: function getProvince() {
      var parsed = this.parseUserRealname(this.user.realname);
      if (parsed) {
        return parsed.city ? parsed.city : null;
      }
      return null;
    },
    hasActiveStory: function hasActiveStory() {
      // Check if user has an active story using global helper
      if (typeof window !== 'undefined' && window.hasActiveStory) {
        return window.hasActiveStory(this.user.nick);
      }
      return false;
    }
  },
  created: function created() {
    var _this = this;
    this.listen(this.$state, 'simplex.address', function (payload) {
      if (payload.networkid !== _this.network.id || payload.nick.toLowerCase() !== _this.user.nick.toLowerCase()) {
        return;
      }
      _this.remoteSimplexAddress = payload.address;
    });
  },
  methods: {
    parseUserRealname: function parseUserRealname(realname) {
      // Regex: (Gender)(Age)(City)_any
      // Gender: M, F, U
      // Age: 2 digits or UU
      // City: 2 letters or UU (e.g. MI, FR, UU)
      var match = (typeof realname === 'string' ? realname : '').match(/^([MFNU])(\d{2}|UU)([A-Z]{2}|UU)_/);
      if (match) {
        return {
          gender: match[1] === 'U' ? null : match[1],
          // Will be 'M', 'F', or 'U'
          age: match[2] === 'UU' ? null : parseInt(match[2], 10),
          // null if 'UU', otherwise number
          city: match[3] === 'UU' ? null : match[3] // null if 'UU', otherwise city code
        };
      }

      return null; // Realname doesn't match the expected format
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;
